<template lang="pug">
  #app
    Topbar
    .page
      router-view(:key="$route.fullPath")
    Footer

    //- scroll top
    a#scroll-top.scroll-top(href='#')
      i.arrow-top.fal.fa-long-arrow-up
      i.arrow-bottom.fal.fa-long-arrow-up

    TopbarMobile
</template>

<script type="text/javascript">
import Footer from "@/components/Footer"
import Topbar from "@/components/Topbar"
import TopbarMobile from "@/components/TopbarMobile"

export default {
  name: "App",
  components: {
    Footer,
    Topbar,
    TopbarMobile,
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss">
@import "style/index";
</style>
